import { Button, CheckItem, Helper, SelectField } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import './GlobalSearchDesktop.css';
import GlobalSearchDesktopInvoices from './GlobalSearchDesktopInvoices/GlobalSearchDesktopInvoices';
import GlobalSearchDesktopJobs from './GlobalSearchDesktopJobs/GlobalSearchDesktopJobs';
import GlobalSearchDesktopOrders from './GlobalSearchDesktopOrders/GlobalSearchDesktopOrders';
import GlobalSearchDesktopTemplates from './GlobalSearchDesktopTemplates/GlobalSearchDesktopTemplates';

const GlobalSearchDesktop = (props) => {
  const domRef = props.domRef ? { ref: props.domRef } : {};

  return (
    <div className="global-search__desktop" {...domRef}>
      <form className="global-search__desktop__form" onSubmit={props.onSubmit}>
        <div className="global-search__desktop__container">
          <h1 className="global-search__desktop__main-title">{i18n.t('globalSearch:Search')}</h1>
          <div className="global-search__desktop__search-type">
            <Helper text={i18n.t('tutorials:search.0')} >
              <SelectField title={i18n.t('globalSearch:Search Type')} value={props.searchType} options={props.searchOptions} onChange={props.onSearchTypeChange} required />
            </Helper>
          </div>
          <div className="global-search__desktop__container__grid">
            { props.searchType === 'templates' &&
              <GlobalSearchDesktopTemplates {...props} />
            }
            { props.searchType === 'jobs' &&
              <GlobalSearchDesktopJobs {...props} />
            }
            { props.searchType === 'supplies' &&
              <GlobalSearchDesktopOrders {...props} />
            }
            { props.searchType === 'invoices' &&
              <GlobalSearchDesktopInvoices {...props} />
            }
            <div>
              <span className="global-search__desktop__container__grid__buttons">
                <Helper text={i18n.t('tutorials:search.1')} >
                  <CheckItem name="exactMatch" title={i18n.t('globalSearch:Exact Match')} checked={props.exactMatch} onClick={props.onToggleExact} />
                </Helper>
                <Helper text={i18n.t('tutorials:search.2')} placement="bottom-left">
                  <Button type="button" onClick={props.onClear} className="button--primary">{i18n.t('globalSearch:Clear')}</Button>
                </Helper>
                <Helper text={i18n.t('tutorials:search.3')} placement="bottom-left">
                  <Button type="submit" className="button--primary">{i18n.t('globalSearch:Search')}</Button>
                </Helper>
              </span>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

GlobalSearchDesktop.propTypes = {
  clientOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  submissionTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    options: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })),
  hasAccessToInvoices: PropTypes.bool,
  domRef: PropTypes.shape({}),
  handleClose: PropTypes.func,
  filterFieldValue: PropTypes.string,
  filterItemValue: PropTypes.string,
  onSubmit: PropTypes.func,
  searchOptions: PropTypes.arrayOf(PropTypes.shape({})),
  onSearchTypeChange: PropTypes.func,
  searchType: PropTypes.string,
  exactMatch: PropTypes.bool,
  onToggleExact: PropTypes.func,
  onClear: PropTypes.func,
};

export default GlobalSearchDesktop;



// WEBPACK FOOTER //
// ./src/components/GlobalSearch/GlobalSearchDesktop/GlobalSearchDesktop.jsx